import MusicLibrary, { MUSIC_LIBRARY_SLICE_TYPE } from 'components/MusicLibrary';
import GetStarted, { GET_STARTED_SLICE_TYPE } from 'components/GetStarted';
import ContactSales, { CONTACT_SALES_SLICE_TYPE } from 'components/ContactSales';

export default {
  [MUSIC_LIBRARY_SLICE_TYPE]: MusicLibrary,
  [GET_STARTED_SLICE_TYPE]: GetStarted,
  [CONTACT_SALES_SLICE_TYPE]: ContactSales,
};
